'use client';

import { c as _c } from "react/compiler-runtime";
import { DebugPanel } from 'vercel-debugpack/browser';

/**
 * DebugPanelWrapper - Shows debug panel on staging/preview environments
 *
 * Just renders the panel - it handles its own visibility internally.
 * Press Ctrl+Shift+; (semicolon) to toggle the debug panel.
 */
export default function DebugPanelWrapper() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DebugPanel config={{
      serverUrl: "https://amara-nonaristocratical-unadulteratedly.ngrok-free.dev"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}